import { combineEpics } from 'redux-observable';
import BookingEpic from './BookingEpic';
import ShopEpic from './ShopEpic';

const epics = combineEpics(
  ...BookingEpic,
  ...ShopEpic,
);

export default epics;
